export const PLUGIN_NAME = 'address-lookup';

// Loqate Address Capture. One base url, so a proxy can replace it later without
// touching the rest of the client.
export const LOQATE_BASE_URL = 'https://api.addressy.com/Capture/Interactive';
// Find is free and called as the customer types; Retrieve is the charged call,
// made once when an address is picked.
export const FIND_PATH = '/Find/v1.20/json6.ws';
export const RETRIEVE_PATH = '/Retrieve/v1.30/json6.ws';

// Kept at 3 rather than lower: each extra character searched is another free Find,
// and too many Finds per paid Retrieve trips Loqate's limit (error 14).
export const MIN_SEARCH_LENGTH = 3;
export const SEARCH_DEBOUNCE_MS = 250;
export const REQUEST_TIMEOUT_MS = 8000;
// Applies to the search results only; a group's contents are listed in full
export const FIND_LIMIT = 10;

export const DEFAULT_COUNTRY = 'GB';

// Find result types that hold an address. Anything else (Postcode, Street,
// BuildingNumber, Residential and so on) is a group to drill into.
export const ADDRESS_TYPE = 'Address';

export const ERROR_CODES = {
  TIMEOUT: 'timeout',
  HTTP: 'http',
  NO_RESULT: 'no_result'
};

export const SEARCH_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  DONE: 'done',
  ERROR: 'error'
};

export const UNAVAILABLE_MESSAGE = 'Address search is unavailable, please enter your address below';
export const NO_RESULTS_MESSAGE = 'No addresses found, please enter your address below';
export const DEFAULT_LABEL = 'Search for your address';
export const DEFAULT_HINT = 'Start typing your address or postcode';
